/**
 * HR Department navigation items.
 * Used by App.js for sidebar/rail navigation and permission-based filtering.
 */
const hrNavigation = [
  {
    path: '/hr/employee-management',
    label: 'Employee Management',
    isParent: true,
    subItems: [
      { path: '/employee-management', label: 'Employee Management', module: 'hr/Employee Management/Employee Management', alternativeModules: ['Employee Management'] },
      { path: '/role-management', label: 'Role Management', module: 'hr/Employee Management/Role Management', alternativeModules: ['Role Management'] },
      { path: '/permission-management', label: 'Permission Management', module: 'hr/Employee Management/Permission Management', alternativeModules: ['Permission Management'] },
      { path: '/attendance', label: 'Attendance', module: 'hr/Employee Management/Attendance', alternativeModules: ['Attendance'] },
      { path: '/my-attendance', label: 'My Attendance', module: 'hr/Employee Management/My Attendance', alternativeModules: ['My Attendance'] }
    ]
  }
];

export default hrNavigation;
